import { defineMessages } from 'react-intl'

export const messages = defineMessages({
  powerFlowHeader: {
    id: 'homeEnergySystem.powerFlowHeader',
    description: 'Header for power flow section',
    defaultMessage: 'Power Flow',
  },
  systemStatusHeader: {
    id: 'homeEnergySystem.systemStatusHeader',
    description: 'Header for system status section',
    defaultMessage: 'System Status',
  },
  batteryHeader: {
    id: 'homeEnergySystem.batteryHeader',
    description: 'Header for battery card',
    defaultMessage: 'Battery{br}{status}',
  },
  generatorHeader: {
    id: 'homeEnergySystem.generatorHeader',
    description: 'Header for generator card',
    defaultMessage: 'Generator{br}{status}',
  },
  solarHeader: {
    id: 'homeEnergySystem.solarHeader',
    description: 'Header for solar card',
    defaultMessage: 'Solar{br}{status}',
  },
  gridHeader: {
    id: 'homeEnergySystem.gridHeader',
    description: 'Header for grid card',
    defaultMessage: 'Grid{br}{status}',
  },
  houseHeader: {
    id: 'homeEnergySystem.houseHeader',
    description: 'Header for house card',
    defaultMessage: 'House{br}consuming',
  },
  charging: {
    id: 'homeEnergySystem.charging',
    description: 'Text for charging status',
    defaultMessage: 'charging',
  },
  inactive: {
    id: 'homeEnergySystem.inactive',
    description: 'Text for inactive status',
    defaultMessage: 'inactive',
  },
  discharging: {
    id: 'homeEnergySystem.discharging',
    description: 'Text for discharging status',
    defaultMessage: 'in use',
  },
  producing: {
    id: 'homeEnergySystem.producing',
    description: 'Text for producing status',
    defaultMessage: 'producing',
  },
  error: {
    id: 'homeEnergySystem.error',
    description: 'Text for error status',
    defaultMessage: 'error',
  },
  exporting: {
    id: 'homeEnergySystem.exporting',
    description: 'Text for exporting status',
    defaultMessage: 'exporting',
  },
  importing: {
    id: 'homeEnergySystem.importing',
    description: 'Text for importing status',
    defaultMessage: 'importing',
  },
  loadStatusHeader: {
    id: 'homeEnergySystem.loadStatusHeader',
    description: 'Header for load status section',
    defaultMessage: 'Load Status',
  },
  headerLoad: {
    id: 'homeEnergySystem.headerLoad',
    description: 'Column header for load table',
    defaultMessage: 'Load',
  },
  headerConsuming: {
    id: 'homeEnergySystem.headerConsuming',
    description: 'Column header for load table',
    defaultMessage: 'Consuming Now',
  },
  headerStatus: {
    id: 'homeEnergySystem.headerStatus',
    description: 'Column header for load table',
    defaultMessage: 'Status',
  },
  headerState: {
    id: 'homeEnergySystem.headerState',
    description: 'Column header for load table',
    defaultMessage: 'State',
  },
  stateOn: {
    id: 'homeEnergySystem.stateOn',
    description: 'On state for load table',
    defaultMessage: 'On',
  },
  stateOff: {
    id: 'homeEnergySystem.stateOff',
    description: 'Off state for load table',
    defaultMessage: 'Off',
  },
  searchPlaceholder: {
    id: 'homeEnergySystem.searchPlaceholder',
    description: 'Search placeholder for the table',
    defaultMessage: 'Search Load',
  },
  director: {
    id: 'homeEnergySystem.director',
    description: 'Director card status',
    defaultMessage: 'Director',
  },
  online: {
    id: 'homeEnergySystem.online',
    description: 'Channel online',
    defaultMessage: 'Online',
  },
  offline: {
    id: 'homeEnergySystem.offline',
    description: 'Channel offline',
    defaultMessage: 'Offline',
  },
  powerModules: {
    id: 'homeEnergySystem.powerModules',
    description: 'Power Modules card status',
    defaultMessage: 'Power Modules',
  },
  ess: {
    id: 'homeEnergySystem.ess',
    description: 'ESS card status',
    defaultMessage: 'ESS',
  },
  updates: {
    id: 'homeEnergySystem.updates',
    description: 'Updates card status',
    defaultMessage: 'Updates',
  },
  directorVersion: {
    id: 'homeEnergySystem.directorVersion',
    description: 'Updates director version label',
    defaultMessage: 'System Version:',
  },
  updated: {
    id: 'homeEnergySystem.updated',
    description: 'Updates updated time label',
    defaultMessage: 'Updated:',
  },
  modulesOffline: {
    id: 'homeEnergySystem.modulesOffline',
    description: 'Modules offline label',
    defaultMessage: '{number} modules offline',
  },
  modulesError: {
    id: 'homeEnergySystem.modulesError',
    description: 'Modules error label',
    defaultMessage: '{number} module errors',
  },
  moduleOffline: {
    id: 'homeEnergySystem.moduleOffline',
    description: 'Module offline label',
    defaultMessage: '{number} module offline',
  },
  moduleError: {
    id: 'homeEnergySystem.moduleError',
    description: 'Module error label',
    defaultMessage: '{number} module error',
  },
  more: {
    id: 'homeEnergySystem.more',
    description: 'Number of error modules',
    defaultMessage: '+ {number} more',
  },
  details: {
    id: 'homeEnergySystem.details',
    description: 'Details button label',
    defaultMessage: 'Details',
  },
  powerModule: {
    id: 'homeEnergySystem.powerModule',
    description: 'Power module header',
    defaultMessage: 'Power Module',
  },
  circuitName: {
    id: 'homeEnergySystem.circuitName',
    description: 'Circuit name header',
    defaultMessage: 'Circuit',
  },
  uid: {
    id: 'homeEnergySystem.uid',
    description: 'UID header',
    defaultMessage: 'UID',
  },
  communicationInterface: {
    id: 'homeEnergySystem.communicationInterface',
    description: 'Communication Interface label',
    defaultMessage: 'Communication Interface',
  },
  communicationStatus: {
    id: 'homeEnergySystem.communicationStatus',
    description: 'Communication Status label',
    defaultMessage: 'Communication Status',
  },
  connected: {
    id: 'homeEnergySystem.connected',
    description: 'Connected label',
    defaultMessage: 'Connected',
  },
  warning: {
    id: 'homeEnergySystem.warning',
    description: 'Warning label',
    defaultMessage: 'Warning',
  },
  savantSystem: {
    id: 'homeEnergySystem.savantSystem',
    description: 'Savant System header',
    defaultMessage: 'Savant System',
  },
  messageCenter: {
    id: 'homeEnergySystem.messageCenter',
    description: 'Message Center header',
    defaultMessage: 'Message Center',
  },
  headerEvent: {
    id: 'homeEnergySystem.headerEvent',
    description: 'Event table header',
    defaultMessage: 'Event',
  },
  headerDate: {
    id: 'homeEnergySystem.headerDate',
    description: 'Date table header',
    defaultMessage: 'Date',
  },
  headerDetails: {
    id: 'homeEnergySystem.headerDetails',
    description: 'Details table header',
    defaultMessage: 'Details',
  },
  periodStart: {
    id: 'homeEnergySystem.periodStart',
    description: 'Total consumption period start',
    defaultMessage: 'Period Start',
  },
  totalConsumption: {
    id: 'homeEnergySystem.totalConsumption',
    description: 'Total consumption period label',
    defaultMessage: 'Total Consumption',
  },
  sceneName: {
    id: 'homeEnergySystem.sceneName',
    description: 'Scene Name',
    defaultMessage: 'Scene Name',
  },
  loadName: {
    id: 'homeEnergySystem.loadName',
    description: 'Load Name',
    defaultMessage: 'Load Name',
  },
  energyUnavailable: {
    id: 'homeEnergySystem.energyUnavailable',
    description: 'No energy system message',
    defaultMessage: "Home doesn't have energy monitoring",
  },
  deviceModel: {
    id: 'homeEnergySystem.devicemodel',
    description: 'ESS model header',
    defaultMessage: 'Device Model',
  },
  cellular: {
    id: 'homeEnergySystem.cellular',
    description: 'Cellular label',
    defaultMessage: 'Cellular',
  },
  wifi: {
    id: 'homeEnergySystem.wifi',
    description: 'Wifi label',
    defaultMessage: 'Wi-Fi',
  },
  circuitExceeded: {
    id: 'homeEnergySystem.circuitExceeded',
    description: 'Max wattage exceeded message details',
    defaultMessage:
      '{loadName} is consuming {power} and has exceeded its configured max wattage of {maxPower}. Please adjust configuration of max wattages to match actual usage.',
  },
})
